import { render, staticRenderFns } from "./riverLakeIslandItem.vue?vue&type=template&id=aafcc46a&scoped=true&"
import script from "./riverLakeIslandItem.vue?vue&type=script&lang=js&"
export * from "./riverLakeIslandItem.vue?vue&type=script&lang=js&"
import style0 from "./riverLakeIslandItem.vue?vue&type=style&index=0&id=aafcc46a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafcc46a",
  null
  
)

export default component.exports